export const BID = {
    /** 整体曝光MV */
    OVERALL_MV: 'b_daodian_lowcode_ks0lvg1m_mv',
    /** 卡片曝光MV */
    CARD_MV: 'b_daodian_lowcode_fbbzl9ub_mv',
    /** 卡片点击MC */
    CARD_MC: 'b_daodian_lowcode_4qw1iq5a_mc'
};
